module.exports = __webpack_public_path__ + "static/media/calculate-02.cefc27cc.svg";